var map = {
	"./coffee_grab.wav": 1223,
	"./coffee_machine.wav": 5176,
	"./coffee_place.wav": 6082,
	"./desert_machine.wav": 4791,
	"./dishwasher_door.wav": 6077,
	"./door.wav": 4430,
	"./drink machine.wav": 8551,
	"./drink.wav": 4836,
	"./drink_grab.wav": 1249,
	"./drink_place.wav": 6904,
	"./eat_version1.wav": 6146,
	"./eat_version2.wav": 1069,
	"./eat_version3.wav": 4340,
	"./light_beep.wav": 2237,
	"./order_ready.wav": 1086,
	"./plate_grab_version1.wav": 8167,
	"./plate_grab_version2.wav": 1200,
	"./plate_grab_version3.wav": 793,
	"./plate_place_version1.wav": 4812,
	"./plate_place_version2.wav": 1155,
	"./plate_place_version3.wav": 7146,
	"./shift_summery.wav": 4507,
	"./sit_booth_off.wav": 3633,
	"./sit_booth_on.wav": 3373,
	"./sit_single_off.wav": 9855,
	"./sit_single_on.wav": 4115,
	"./tip_recieve.wav": 9415,
	"./ui_approve_high_b.wav": 3166,
	"./ui_approve_low_b.wav": 5762,
	"./ui_bon_action.wav": 6177,
	"./ui_bon_done.wav": 4987,
	"./ui_bon_in.wav": 3506,
	"./ui_bon_out.wav": 3761,
	"./ui_clock_count.wav": 455,
	"./ui_coin_earn.wav": 2053,
	"./ui_coin_spend.wav": 1841,
	"./ui_error.wav": 7299,
	"./ui_general_b.wav": 8166,
	"./ui_interacting_pop_bubble.wav": 9568,
	"./ui_mouseover.wav": 2818,
	"./ui_pop_bubble_click_version1.wav": 5446,
	"./ui_pop_bubble_click_version2.wav": 7185,
	"./ui_swish_in.wav": 9895,
	"./ui_swish_out.wav": 1018,
	"./ui_top_menu_close.wav": 4187,
	"./ui_top_menu_open.wav": 2729,
	"./ui_totall_new_record.wav": 538,
	"./ui_user_pop_bubble.wav": 2487,
	"./ui_wobble_in.wav": 5346,
	"./ump_into_role.wav": 1140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8460;